import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MasterserviceService } from '../../../dataservices/master-service/masterservice.service';
import { NewLanguageService } from '../../../dataservices/new-language/new-language.service';
@Component({
  selector: 'app-map-association',
  templateUrl: './map-association.component.html',
  styleUrls: ['./map-association.component.scss']
})
export class MapAssociationComponent {
  @Input() dataObj;
  @Input() callingfrom;
  @Output() emitButtonClicked: EventEmitter<null> = new EventEmitter();
  isShownWebModal = false;
  displaySection = '';
  displayObj = {
    isShow: false,
    display_section: '',
    data: [],
    errObj: []
  };

  constructor(private masterSer: MasterserviceService, public mls: NewLanguageService) { }

  showWebModal(section): void {
    this.emitButtonClicked.emit();
    this.displayObj.isShow = true;
    this.displayObj.display_section = section;
    this.masterSer.showWebModal.next(this.displayObj);
  }

}
